// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

var axios = require('axios')
Vue.prototype.$axios = axios
axios.defaults.baseURL = 'http://localhost:5000/task'
Vue.config.productionTip = false
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth  === true) {
      if (store.state.access_token) {
        axios.post('/authentication',{
          access_token: store.state.access_token
        }).then(resp => {
          if (resp.data.code === 200) {
            next()
          }else {
            next('/login');
          }
        })
      } else {
        next('/login');
      }
    } else {
      next()
    }
  }
)

new Vue({
  el: '#app_vx',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js